import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GlobalThemeProvider } from '@zoom/react-ui'
import semver from 'semver'
import { selectZaConfig, selectZaConfigError } from './reducer'
import { cancelZaConfig, zaConfig } from './actions'
import ClientSetting from '../clientSetting/ClientSetting'
import NewClientSetting from '../clientSetting/NewClientSetting'
import useScreenDimensions from '../util/useScreenDimensions'
import App from './App'
import useLightModePreference from '../util/useLightModePreference'

const CLIENT_SETTING_VIEW_DIMENSIONS = {
  width: 485,
  height: 405,
}

const NEW_CLIENT_SETTING_MIN_VERSION = '7.1.0'

const Entry = () => {
  const isLightMode = useLightModePreference()
  const dispatch = useDispatch()
  const zaConfigOutput = useSelector(selectZaConfig)
  const zaConfigError = useSelector(selectZaConfigError)
  const screenDimensions = useScreenDimensions()
  const isClientSettingPreview =
    new URLSearchParams(window.location.search).get('view') === 'clientSetting'
  const showClientSetting =
    isClientSettingPreview ||
    (!zaConfigOutput &&
      screenDimensions.width <= CLIENT_SETTING_VIEW_DIMENSIONS.width &&
      screenDimensions.height <= CLIENT_SETTING_VIEW_DIMENSIONS.height) ||
    zaConfigOutput?.launchContext?.origin === 'Client Setting'
  const normalizedClientVersion = zaConfigOutput?.clientVersion
    ?.split('.', 3)
    .join('.')
  const shouldUseNewClientSetting = normalizedClientVersion
    ? semver.gte(normalizedClientVersion, NEW_CLIENT_SETTING_MIN_VERSION)
    : false
  const shouldWaitForClientSettingVersion =
    showClientSetting &&
    !isClientSettingPreview &&
    !zaConfigOutput &&
    !zaConfigError

  useEffect(() => {
    dispatch(zaConfig())

    return () => {
      dispatch(cancelZaConfig())
    }
  }, [dispatch])

  if (shouldWaitForClientSettingVersion) {
    return (
      <GlobalThemeProvider defaultMode={isLightMode ? 'light' : 'dark'}>
        <div />
      </GlobalThemeProvider>
    )
  }

  return showClientSetting ? (
    <GlobalThemeProvider defaultMode={isLightMode ? 'light' : 'dark'}>
      {shouldUseNewClientSetting ? <NewClientSetting /> : <ClientSetting />}
    </GlobalThemeProvider>
  ) : (
    <GlobalThemeProvider defaultMode="light">
      <App />
    </GlobalThemeProvider>
  )
}

export default Entry
